export default __webpack_public_path__ + "static/media/img-gestionale-discover-1.c7dcb4e0.png";